<template>
	<div class="row contentblock">
		<div class="columns column6 col-image">
			<picture>
				<source :srcset="imageWebp" type="image/webp" />
				<source :srcset="image" />
				<img :src="image" :alt="imageAlt" loading="lazy" />
			</picture>
		</div>
		<div class="columns column4 col-content">
			<div class="contentblock-content">
				<h3>{{ header }}</h3>
				<div v-parse-links v-html="content" />
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	image: { type: String, default: '' },
	imageWebp: { type: String, default: '' },
	imageAlt: { type: String, default: '' },
	header: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.contentblock {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	padding: 0;
	margin: 40px auto;
	position: relative;
	width: 100%;
	max-width: 100vw;

	&:nth-child(odd) {
		flex-direction: row-reverse;

		.col-content {
			margin-left: auto;
			margin-right: calc(50vw - 700px);
		}

		.col-image {
			left: 0;
			right: auto;
		}
	}

	.columns:first-child {
		padding: 0;
	}

	img {
		object-fit: cover;
		width: 100%;
		height: 100%;
	}

	.col-content {
		padding: 50px 0;
		position: relative;
		z-index: 2;
		margin-left: calc(50vw - 700px);
		max-width: 500px;
	}

	.col-image {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		width: calc(50vw + 350px);
		z-index: 1;
	}

	.contentblock-content {
		padding: 50px;
		background: #fff;
	}
}

@media (max-width: 1420px) {
	.contentblock {
		.col-content {
			margin-left: 20px;
		}

		&:nth-child(odd) {
			.col-content {
				margin-right: 20px;
			}
		}
	}
}

@media (max-width: 1080px) {
	.contentblocks {
		overflow: hidden;
	}

	.contentblock {
		flex-flow: column !important;

		.col-image {
			width: 100%;
			position: relative;
			inset: auto;
			margin: 0 auto -30px;
		}

		.col-content {
			padding: 0;
			width: 100%;
			margin: 0 auto;
		}

		.contentblock-content {
			padding: 40px;
		}
	}
}

@media (max-width: 580px) {
	.contentblock {
		margin-bottom: 25px;

		.contentblock-content {
			padding: 35px;
		}
	}
}
</style>
